var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _vm.inventory
    ? _c("div", [
        _c("div", { staticClass: "row" }, [
          _c("div", { staticClass: "col-md-3" }, [
            _c("small", [
              _c("strong", [_vm._v(_vm._s(_vm.$t("inventoryName")))])
            ]),
            _vm._v(" "),
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.inventory.name,
                  expression: "inventory.name"
                }
              ],
              staticClass: "form-control",
              attrs: {
                type: "text",
                placeholder: _vm.$t("inventoryName").toString()
              },
              domProps: { value: _vm.inventory.name },
              on: {
                input: function($event) {
                  if ($event.target.composing) return
                  _vm.$set(_vm.inventory, "name", $event.target.value)
                }
              }
            })
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "col-md-3" }, [
            _c("small", [_vm._v(_vm._s(_vm.$t("inventoryIdent")))]),
            _vm._v(" "),
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.inventory.ident,
                  expression: "inventory.ident"
                }
              ],
              staticClass: "form-control",
              attrs: {
                type: "text",
                placeholder: _vm.$t("inventoryIdent").toString()
              },
              domProps: { value: _vm.inventory.ident },
              on: {
                input: function($event) {
                  if ($event.target.composing) return
                  _vm.$set(_vm.inventory, "ident", $event.target.value)
                }
              }
            })
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "col-md-3" },
            [
              _c("small", [_vm._v(_vm._s(_vm.$t("inventoryLastChange")))]),
              _vm._v(" "),
              _c("DatePicker", {
                attrs: { "input-class": "form-control", disabled: true },
                model: {
                  value: _vm.inventory.updatedAt,
                  callback: function($$v) {
                    _vm.$set(_vm.inventory, "updatedAt", $$v)
                  },
                  expression: "inventory.updatedAt"
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "col-md-3" },
            [
              _c("small", [_vm._v(_vm._s(_vm.$t("txtInvEntryDate")))]),
              _vm._v(" "),
              _c("DatePicker", {
                attrs: { "input-class": "form-control" },
                model: {
                  value: _vm.inventory.entryDate,
                  callback: function($$v) {
                    _vm.$set(_vm.inventory, "entryDate", $$v)
                  },
                  expression: "inventory.entryDate"
                }
              })
            ],
            1
          )
        ]),
        _vm._v(" "),
        _c("hr"),
        _vm._v(" "),
        _c("div", { staticClass: "row" }, [
          _c("div", { staticClass: "col-md-3" }, [
            _c("small", [_vm._v(_vm._s(_vm.$t("txtInvlocation")))]),
            _vm._v(" "),
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.inventory.location,
                  expression: "inventory.location"
                }
              ],
              staticClass: "form-control",
              attrs: {
                type: "text",
                placeholder: _vm.$t("txtInvlocation").toString()
              },
              domProps: { value: _vm.inventory.location },
              on: {
                input: function($event) {
                  if ($event.target.composing) return
                  _vm.$set(_vm.inventory, "location", $event.target.value)
                }
              }
            })
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "col-md-9" }, [
            _c("small", [_vm._v(_vm._s(_vm.$t("txtInvGeneral")))]),
            _vm._v(" "),
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.inventory.generalInfo,
                  expression: "inventory.generalInfo"
                }
              ],
              staticClass: "form-control",
              attrs: {
                type: "text",
                placeholder: _vm.$t("txtInvGeneral").toString()
              },
              domProps: { value: _vm.inventory.generalInfo },
              on: {
                input: function($event) {
                  if ($event.target.composing) return
                  _vm.$set(_vm.inventory, "generalInfo", $event.target.value)
                }
              }
            })
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "row" }, [
          _c("div", { staticClass: "col-md-3" }, [
            _c("small", [_vm._v(_vm._s(_vm.$t("txtInvSupplier")))]),
            _vm._v(" "),
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.inventory.supplier,
                  expression: "inventory.supplier"
                }
              ],
              staticClass: "form-control",
              attrs: {
                type: "text",
                placeholder: _vm.$t("txtInvSupplier").toString()
              },
              domProps: { value: _vm.inventory.supplier },
              on: {
                input: function($event) {
                  if ($event.target.composing) return
                  _vm.$set(_vm.inventory, "supplier", $event.target.value)
                }
              }
            })
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "col-md-9" }, [
            _c("small", [_vm._v(_vm._s(_vm.$t("txtInvComment")))]),
            _vm._v(" "),
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.inventory.comment,
                  expression: "inventory.comment"
                }
              ],
              staticClass: "form-control",
              attrs: {
                type: "text",
                placeholder: _vm.$t("txtInvComment").toString()
              },
              domProps: { value: _vm.inventory.comment },
              on: {
                input: function($event) {
                  if ($event.target.composing) return
                  _vm.$set(_vm.inventory, "comment", $event.target.value)
                }
              }
            })
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "row" }, [
          _c("div", { staticClass: "col-md-3" }, [
            _c("small", [_vm._v(_vm._s(_vm.$t("txtCostCenter")))]),
            _vm._v(" "),
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.inventory.costCenter,
                  expression: "inventory.costCenter"
                }
              ],
              staticClass: "form-control",
              attrs: {
                type: "text",
                placeholder: _vm.$t("txtCostCenter").toString()
              },
              domProps: { value: _vm.inventory.costCenter },
              on: {
                input: function($event) {
                  if ($event.target.composing) return
                  _vm.$set(_vm.inventory, "costCenter", $event.target.value)
                }
              }
            })
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "col-md-3" }, [
            _c("small", [_vm._v(_vm._s(_vm.$t("inventoryRiskInfo")))]),
            _vm._v(" "),
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.inventory.riskInfo,
                  expression: "inventory.riskInfo"
                }
              ],
              staticClass: "form-control",
              attrs: {
                type: "text",
                placeholder: _vm.$t("inventoryRiskInfo").toString()
              },
              domProps: { value: _vm.inventory.riskInfo },
              on: {
                input: function($event) {
                  if ($event.target.composing) return
                  _vm.$set(_vm.inventory, "riskInfo", $event.target.value)
                }
              }
            })
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "col-md-6" }, [
            _c("small", [_vm._v(_vm._s(_vm.$t("inventoryTechArea")))]),
            _vm._v(" "),
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.inventory.techArea,
                  expression: "inventory.techArea"
                }
              ],
              staticClass: "form-control",
              attrs: {
                type: "text",
                placeholder: _vm.$t("inventoryTechArea").toString()
              },
              domProps: { value: _vm.inventory.techArea },
              on: {
                input: function($event) {
                  if ($event.target.composing) return
                  _vm.$set(_vm.inventory, "techArea", $event.target.value)
                }
              }
            })
          ])
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "row" },
          [
            !(_vm.inventory.bins && _vm.inventory.bins.length)
              ? [
                  _c("div", { staticClass: "col-md-3" }, [
                    _c("small", [
                      _vm._v(_vm._s(_vm.$t("inventoryLocationAisle")))
                    ]),
                    _vm._v(" "),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.inventory.locationAisle,
                          expression: "inventory.locationAisle"
                        }
                      ],
                      staticClass: "form-control",
                      attrs: {
                        type: "text",
                        placeholder: _vm
                          .$t("inventory.bin.locationAisle")
                          .toString()
                      },
                      domProps: { value: _vm.inventory.locationAisle },
                      on: {
                        input: function($event) {
                          if ($event.target.composing) return
                          _vm.$set(
                            _vm.inventory,
                            "locationAisle",
                            $event.target.value
                          )
                        }
                      }
                    })
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "col-md-3" }, [
                    _c("small", [
                      _vm._v(_vm._s(_vm.$t("inventoryLocationRow")))
                    ]),
                    _vm._v(" "),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.inventory.locationRow,
                          expression: "inventory.locationRow"
                        }
                      ],
                      staticClass: "form-control",
                      attrs: {
                        type: "text",
                        placeholder: _vm
                          .$t("inventory.bin.locationRow")
                          .toString()
                      },
                      domProps: { value: _vm.inventory.locationRow },
                      on: {
                        input: function($event) {
                          if ($event.target.composing) return
                          _vm.$set(
                            _vm.inventory,
                            "locationRow",
                            $event.target.value
                          )
                        }
                      }
                    })
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "col-md-3" }, [
                    _c("small", [
                      _vm._v(_vm._s(_vm.$t("inventoryLocationPin")))
                    ]),
                    _vm._v(" "),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.inventory.locationPin,
                          expression: "inventory.locationPin"
                        }
                      ],
                      staticClass: "form-control",
                      attrs: {
                        type: "text",
                        placeholder: _vm
                          .$t("inventory.bin.locationPin")
                          .toString()
                      },
                      domProps: { value: _vm.inventory.locationPin },
                      on: {
                        input: function($event) {
                          if ($event.target.composing) return
                          _vm.$set(
                            _vm.inventory,
                            "locationPin",
                            $event.target.value
                          )
                        }
                      }
                    })
                  ])
                ]
              : _c("div", { staticClass: "col-md-9" }),
            _vm._v(" "),
            _c("div", { staticClass: "col-md-3" }, [
              _c("small", [_vm._v(_vm._s(_vm.$t("inventoryUnit")))]),
              _vm._v(" "),
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.inventory.unit,
                    expression: "inventory.unit"
                  }
                ],
                staticClass: "form-control",
                attrs: {
                  type: "text",
                  placeholder: _vm.$t("inventoryUnit").toString()
                },
                domProps: { value: _vm.inventory.unit },
                on: {
                  input: function($event) {
                    if ($event.target.composing) return
                    _vm.$set(_vm.inventory, "unit", $event.target.value)
                  }
                }
              })
            ])
          ],
          2
        ),
        _vm._v(" "),
        _c("div", { staticClass: "row" }, [
          _c("div", { staticClass: "col-md-6" }, [
            _c("small", [_vm._v(_vm._s(_vm.$t("txtInvPrice")))]),
            _vm._v(" "),
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.inventory.price,
                  expression: "inventory.price"
                }
              ],
              staticClass: "form-control",
              attrs: {
                type: "text",
                placeholder: _vm.$t("txtInvPrice").toString()
              },
              domProps: { value: _vm.inventory.price },
              on: {
                input: function($event) {
                  if ($event.target.composing) return
                  _vm.$set(_vm.inventory, "price", $event.target.value)
                }
              }
            })
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "col-md-6" }, [
            _c("small", [_vm._v(_vm._s(_vm.$t("txtInvOnStock")))]),
            _vm._v(" "),
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.inventory.itemsOnStock,
                  expression: "inventory.itemsOnStock"
                }
              ],
              staticClass: "form-control",
              attrs: {
                type: "text",
                placeholder: _vm.$t("txtInvOnStock").toString()
              },
              domProps: { value: _vm.inventory.itemsOnStock },
              on: {
                input: function($event) {
                  if ($event.target.composing) return
                  _vm.$set(_vm.inventory, "itemsOnStock", $event.target.value)
                }
              }
            })
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "row" }, [
          _c("div", { staticClass: "col-md-6" }, [
            _c("small", [_vm._v(_vm._s(_vm.$t("txtInvNominalStock")))]),
            _vm._v(" "),
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.inventory.nominalStock,
                  expression: "inventory.nominalStock"
                }
              ],
              staticClass: "form-control",
              attrs: {
                type: "text",
                placeholder: _vm.$t("txtInvNominalStock").toString()
              },
              domProps: { value: _vm.inventory.nominalStock },
              on: {
                input: function($event) {
                  if ($event.target.composing) return
                  _vm.$set(_vm.inventory, "nominalStock", $event.target.value)
                }
              }
            })
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "col-md-6" }, [
            _c("small", [_vm._v(_vm._s(_vm.$t("txtInvLowStockSP")))]),
            _vm._v(" "),
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.inventory.lowStockSetpoint,
                  expression: "inventory.lowStockSetpoint"
                }
              ],
              staticClass: "form-control",
              attrs: {
                type: "text",
                placeholder: _vm.$t("txtInvLowStockSP").toString()
              },
              domProps: { value: _vm.inventory.lowStockSetpoint },
              on: {
                input: function($event) {
                  if ($event.target.composing) return
                  _vm.$set(
                    _vm.inventory,
                    "lowStockSetpoint",
                    $event.target.value
                  )
                }
              }
            })
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "row" }, [
          _c("div", { staticClass: "col-md-6" }, [
            _c("small", [_vm._v(_vm._s(_vm.$t("txtInvGTIN")))]),
            _vm._v(" "),
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.inventory.gtin,
                  expression: "inventory.gtin"
                }
              ],
              staticClass: "form-control",
              attrs: {
                type: "text",
                placeholder: _vm.$t("txtInvGTIN").toString()
              },
              domProps: { value: _vm.inventory.gtin },
              on: {
                input: function($event) {
                  if ($event.target.composing) return
                  _vm.$set(_vm.inventory, "gtin", $event.target.value)
                }
              }
            })
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "col-md-6" }, [
            _c("small", [_vm._v(_vm._s(_vm.$t("txtBeaconId")))]),
            _vm._v(" "),
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.inventory.beaconId,
                  expression: "inventory.beaconId"
                }
              ],
              staticClass: "form-control",
              attrs: {
                type: "text",
                placeholder: _vm.$t("txtBeaconId").toString()
              },
              domProps: { value: _vm.inventory.beaconId },
              on: {
                input: function($event) {
                  if ($event.target.composing) return
                  _vm.$set(_vm.inventory, "beaconId", $event.target.value)
                }
              }
            })
          ])
        ])
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }